<div class="todo-content">
  <div class="container">
    <div class="ranking_title mt-5">تودولیست</div>
    <div class="ranking_excerpt">در این قسمت میتوانید لیستی از تمام کارهایی که میخواهید انجام دهید بسازید. </div>
    <div class="add-task mt-5">
      <div class="row">
        <div class="add_new_task">
          <form action="">
            <div class="cat_task">
              <input (change)="saveToCategories(this.myControl.value)" type="text"
                     placeholder="{{ 'Category' | translate }}"
                     matInput [formControl]="myControl" [matAutocomplete]="auto"
                     [(ngModel)]="todo.category_title" [value]="todo.category_title">
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let category of pomodoroRepository.categories" [value]="category">
                  {{category}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="title_task">
              <input type="text" class="cat_task" [value]="todo.desc"
                     placeholder="{{ 'ShortDescription' | translate }}"
                     [(ngModel)]="todo.desc" name="task.description" (keyup.enter)="addItem()">
            </div>
            <div class="add_task_button">
              <button type="button" (click)="addItem()"><i class="icon-plus"></i></button>
            </div>
            <div class="clearfix"></div>
          </form>
        </div><!-- .add_new_task -->
      </div>
    </div>
    <div class="header_task mt-3" *ngIf="pomodoroRepository.listReturners().length !== 0">
      <div class="col_task col_task1 pointer mark-all-task">
        <input id="mark-all-tasks" type="checkbox" [(ngModel)]="markAllCtrl" (click)="markAllTodos(markAllCtrl)">
        <label for="mark-all-tasks">انتخاب همه کارها</label>
      </div>
      <div class="col_task float-left pointer" *ngIf="showImportToMainButton || markAllCtrl">
<!--      <div class="col_task float-left pointer">-->
        <button class="mark-all-btn" (click)="addAllToMainPage()">انتقال کارهای انتخاب شده به صفحه اصلی</button>
      </div>
      <div class="clearfix"></div>
    </div><!-- .task -->
    <ng-container>
      <div class="drag-drop example-list" cdkDropList #todoList="cdkDropList"
           [cdkDropListData]="pomodoroRepository.listReturners()"
           [cdkDropListConnectedTo]="[todoList]"
           (cdkDropListDropped)="drop($event)">
        <div class="task" *ngFor="let item of pomodoroRepository.listReturners()"
             title="{{ 'clickToEdit' | translate }}" cdkDrag>
          <div class="col_task todo-col-task1 per-task">
            <input id="mark-per-task" type="checkbox" [(ngModel)]="item.is_mark">
            <label for="{{item.id}}" (click)="markOneTask(item)"></label>
          </div>
          <div *ngIf="!item.is_edit" class="col_task todo-col-task2">
            <div class="task_desc" (click)="showInput(item)">{{item.category_title}}</div>
          </div>
          <div *ngIf="item.is_edit" class="col_task col_task1">
            <input class="input_v2 todo_category_input" (change)="saveToCategoriesTasks(item)" type="text"
                   placeholder="{{ 'Category' | translate }}"
                   aria-label="Number" matInput [matAutocomplete]="auto"
                   [(ngModel)]="item.category_title" value="category">
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let category of pomodoroRepository.categories" [value]="category">
                {{category}}
              </mat-option>
            </mat-autocomplete>
          </div>
          <div *ngIf="!item.is_edit" class="col_task todo-col-task3">
            <div class="task_desc" (click)="showInput(item)">{{item.desc}}</div>
          </div>
          <div *ngIf="item.is_edit" class="col_task todo-col-task3">
            <input type="text" id="desc"
                   (keyup.enter)="backToDes(item)"
                   class="edit-input todo_desc_input" placeholder="{{ 'Title' | translate }}"
                   [(ngModel)]="item.desc" name="task.desc">
          </div>
          <div class="col_task col_task5 float-left ml-2">
            <button [matMenuTriggerFor]="menu" class="more_option_button">
              <i class="icon-ellipsis-h-alt"></i>
            </button>
            <mat-menu #menu="matMenu" class="customize-todo-menu">
              <button mat-menu-item class="customize-todo-menu-btn" (click)="addOneToMainPage(item)">
                <mat-icon> import_export</mat-icon>
                <span class="icon-txt">انتقال کار به صفحه اصلی</span>
              </button>
              <button mat-menu-item class="customize-todo-menu-btn" (click)="deleteItem(item)">
                <mat-icon>delete_forever</mat-icon>
                <span class="icon-txt">حذف کار</span>
              </button>
              <button mat-menu-item class="customize-todo-menu-btn" (click)="showInput(item)">
                <mat-icon>edit</mat-icon>
                <span class="icon-txt">ویرایش کار</span>
              </button>
            </mat-menu>
          </div>
          <div class="clearfix"></div>
        </div><!-- .task -->
      </div>
    </ng-container>
    <div class="my-5 text-center" *ngIf="pomodoroRepository.listReturners().length === 0">
      <div class="to_do_list_empty_box text-right">
        <img src="assets/image/pomodoro-illustration.svg" alt="pomodoro-illustration">
        <div class="title_to_do_list_empty_box">
          بفرما بساز
        </div>
        <div class="excerpt_to_do_list_empty_box">
          در این قسمت میتوانید لیستی از تمام کارهایی که میخواهید انجام دهید بسازید.
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>
<app-footer></app-footer>
